export const paymentMethodItems = [
  { text: "集金", value: null },
  { text: "口座振替", value: "withdrawal" },
  { text: "振り込み", value: "invoice" },
  { text: "クレジットカード", value: "card" },
];
